import { API_BASE_URL, getRequest, patchRequest } from "../../api";

const getToken = () => sessionStorage.getItem("token");
const getUid = () => sessionStorage.getItem("uid");

export const fetchContentQuestionNotificationsApi = () =>
    getRequest({
        url: `${API_BASE_URL}/api/apprenant/questions/notifications`,
        token: getToken(),
        uid: getUid(),
    });

export const fetchMentionableUsersApi = (moduleId, query = "") =>
    getRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/mentionable-users?query=${encodeURIComponent(query)}`,
        token: getToken(),
        uid: getUid(),
    });

export const markContentQuestionNotificationReadApi = (notificationId) =>
    patchRequest({
        url: `${API_BASE_URL}/api/apprenant/questions/notifications/${notificationId}/read`,
        data: {},
        token: getToken(),
        uid: getUid(),
    });

export const markAllContentQuestionNotificationsReadApi = () =>
    patchRequest({
        url: `${API_BASE_URL}/api/apprenant/questions/notifications/read-all`,
        data: {},
        token: getToken(),
        uid: getUid(),
    });
